import { PhoneCountryCodeType } from '@bus/models';
import { CorrespondenceMethodEnum } from '../../../../../types/forms';
import { CompanyDetailsFormModel_ST_OL } from './formModel';

export const getInitialValues = (): CompanyDetailsFormModel_ST_OL => {
  return {
    tradingName: undefined,
    legalName: undefined,
    fleetSize: undefined,
    dateOfIncorporation: undefined,
    businessType: undefined,
    businessSubType: undefined,
    countryCode: PhoneCountryCodeType.Ireland,
    phoneNumber: undefined,
    email: undefined,
    vatLiable: undefined,
    vatNumber: undefined,
    correspondenceMethod: CorrespondenceMethodEnum.email,
  };
};
